import {HTTP} from "../../helpers/axios";
// src/thunks.ts
import { Action } from 'redux'
import {RootState} from '../../reducers'
import { ThunkAction } from 'redux-thunk'
import { serverRoutes} from "../../api/serverRoutes";


export const editCustomerAction = (customer:object,callback:(error:boolean)=>void):ThunkAction<void, RootState, unknown, Action<string>> => async (dispatch,getState) => {
    let error=false;
    try {
        const response =  await   HTTP(getState,dispatch).put(serverRoutes.editCustomer,customer);

        callback(error);
    }catch (e) {
        error=true;
        callback(error)
    }


};

export default editCustomerAction;
